import React from "react";
import MessagePanelList from "./MessagePanelList";

const MessageDashBoard = ({ messages = [] }) => {
    return (
        <div className="flex-1 outline-none space-y-4 sm:space-y-6"> 
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6">
                <MessagePanelList filteredMessages={messages}  />
            </div>
        </div>
    )
};
export default MessageDashBoard;